<template>
    <span class="wrap">
        <input class="fct-input"
               @input="$emit('input', $event.target.value.split(/\s+/g).join(''))"
               @change="$emit('change', $event)"
               :value="value"
               :type="inputType">
        <a class="input-icon" :class="{active: inputVisible}" @click="toggleShowInput()"><i class="fct-admin-icon-eye"></i></a>
    </span>
</template>

<script>
  export default {
    props: ['value'],
    data () {
      return {
        inputVisible: false,

      }
    },
    methods: {
      toggleShowInput() {
        this.inputVisible = !this.inputVisible
      }
    },
    computed: {
      inputType() {
        return this.inputVisible ? 'text' : 'password'
      }
    }
  }
</script>

<style scoped>

</style>
